// extracted by mini-css-extract-plugin
export default {"buttonCol":"CampaignsCarousel-module--buttonCol--e08f4"};